import { config, ignoreLoginPath } from 'env_def';
import { initWindowLang } from './utils/global_label';
import { api } from './api/api';
import implsList, { apisManager, initApi } from './gen/impl_list';
import { apis, inWindow, isElectron, jumpLogin, loginFlag, loginPage, isLowMemoryMode } from './config';
import { pathNotInArrJudge, isSupportNativeProxy } from './api/util';
import { globalStoreConfig } from '@/api/data/store';
import { bridgeInit } from './bridge/index';
import { getIsLoginPage } from './utils/isLocPage';
import { inWindowTool } from './utils/inWindow';
import { getOs } from './utils/confOs';
export { getUploadApi, NosUploadHelper } from './impl/logical/mail/mail_slice_upload_helper';
export const apiManager = apisManager;
if (inWindowTool()) {
    window.apiManager = apiManager;
}
export const apiHolder = {
    api: api,
    features: implsList,
    env: {
        forElectron: config('build_for') === 'electron',
        isMac: getOs() === 'mac',
        os: getOs(),
    },
    initModule: false,
};
export const conf = config;
export const http = {
    timeout: 3000,
};
apiManager.registerApiPolicy({
    target: apis.upgradeAppApiImpl,
    called: new Set(),
    canRecall: () => true,
    exclude: (apiName, ev) => {
        const loc = apiName === 'onPathChange' ? (ev === null || ev === void 0 ? void 0 : ev.curPath) || window.location : window.location;
        return pathNotInArrJudge(loc, ['/']);
    },
});
apiManager.registerApiPolicy({
    target: apis.taskApiImpl,
    called: new Set(),
    canRecall: () => true,
    exclude: () => {
        const loc = window.location;
        return pathNotInArrJudge(loc, ['/', '/launch/', '/jump/']);
    },
});
apiManager.registerApiPolicy({
    target: apis.imApiImpl,
    called: new Set(),
    canRecall: apiName => ['afterLogin', 'beforeLogout', 'onPathChange', 'init'].includes(apiName),
    exclude: (apiName, ev) => {
        if (apiName === 'afterLogin' || apiName === 'beforeLogout') {
            return false;
        }
        const loc = apiName === 'onPathChange' ? (ev === null || ev === void 0 ? void 0 : ev.curPath) || window.location : window.location;
        return pathNotInArrJudge(loc, ['/', '/launch/']);
    },
});
apiManager.registerApiPolicy({
    target: apis.pushApiImpl,
    called: new Set(),
    canRecall: () => true,
    exclude: (apiName, ev) => {
        const loc = apiName === 'onPathChange' ? (ev === null || ev === void 0 ? void 0 : ev.curPath) || window.location : window.location;
        return pathNotInArrJudge(loc, ['/', '/launch/']);
    },
});
apiManager.registerApiPolicy({
    target: apis.contactApiImpl,
    called: new Set(),
    canRecall: apiName => ['afterLogin', 'beforeLogout', 'onPathChange'].includes(apiName),
    exclude: (apiName, ev) => {
        console.log('test policy for contact ', apiName, ev);
        const loc = apiName === 'onPathChange' ? (ev === null || ev === void 0 ? void 0 : ev.curPath) || window.location : window.location;
        return pathNotInArrJudge(loc, [
            '/index.html',
            '/',
            '/doc',
            '/sheet',
            '/unitable',
            '/launch',
            '/writeMail',
            '/readMailComb',
            '/contactSync',
            '/scheduleOpPage',
            '/resources',
            ...(process.env.BUILD_ISLINGXI && !process.env.BUILD_ISELECTRON ? ['/readMail'] : []),
            '/api_data_init',
        ]);
    },
});
apiManager.registerApiPolicy({
    target: apis.mailApiImpl,
    called: new Set(),
    canRecall: apiName => ['afterLogin', 'beforeLogout', 'onPathChange', 'init'].includes(apiName),
    exclude: (apiName, ev) => {
        if (apiName === 'afterLogin' || apiName === 'beforeLogout') {
            return false;
        }
        const loc = apiName === 'onPathChange' ? (ev === null || ev === void 0 ? void 0 : ev.curPath) || window.location : window.location;
        const b = pathNotInArrJudge(loc, [
            '/index.html',
            '/',
            '/launch',
            '/writeMail',
            '/readMailComb',
            '/readMail',
            '/strangerMails',
            '/marketingDataViewer',
            '/diagnoseDataViewer',
            '/personalWhatsapp',
            '/marketingTaskPage',
        ]);
        console.log('test policy for mail ' + loc.pathname + ' ' + location.href, b);
        return b;
    },
});
apiManager.registerApiPolicy({
    target: apis.mailConfApiImpl,
    called: new Set(),
    canRecall: apiName => ['afterLogin', 'beforeLogout', 'onPathChange', 'init'].includes(apiName),
    exclude: (apiName, ev) => {
        if (apiName === 'afterLogin' || apiName === 'beforeLogout') {
            return false;
        }
        const loc = apiName === 'onPathChange' ? (ev === null || ev === void 0 ? void 0 : ev.curPath) || window.location : window.location;
        return pathNotInArrJudge(loc, [
            '/index.html',
            '/',
            '/launch',
            '/writeMail',
            '/readMailComb',
            '/readMail',
            '/strangerMails',
            '/marketingDataViewer',
            '/marketingTaskPage',
            '/diagnoseDataViewer',
        ]);
    },
});
initApi();
if (!process.env.BUILD_ISELECTRON) {
    if (isSupportNativeProxy && !getIsLoginPage()) {
        bridgeInit();
    }
}
else {
    if (!isLowMemoryMode) {
        bridgeInit();
    }
}
console.log('----------judge login-----------');
const toLogin = () => {
    const sysApi = window.apiResposity.getSystemApi();
    const loggerApi = window.apiResposity.requireLogicalApi(apis.loggerApiImpl);
    try {
        console.log('----------jump to login-----------');
        if (isElectron() && !sysApi.isMainWindow() && !sysApi.isStartWindow() && window.electronLib) {
            setTimeout(() => {
                if (!sysApi.getCurrentUser())
                    sysApi.closeWindow(false, true);
            }, 1000);
            console.log('[api] should close ', window.location.href);
            loggerApi.track('electron_load_page_login_failed', {
                href: window.location.href,
            });
        }
        jumpLogin();
    }
    catch (ex) {
        console.warn('[api] logout issue:', ex);
        window.location.assign(loginPage);
    }
};
const transferData = async () => {
    const storeApi = window.apiResposity.getDataStoreApi();
    const accountApi = window.apiResposity.requireLogicalApi(apis.accountApiImpl);
    try {
        const res = await window.electronLib.storeManage.get('account');
        const keyDeviceUUID = config('browerDeviceUUID');
        const nodeKey = 'currentNodeStore';
        const { info, node, uuid, accounts } = res;
        console.log('[transfer] data:', res);
        if (node) {
            storeApi.putSync(nodeKey, node, globalStoreConfig);
        }
        if (uuid) {
            storeApi.putSync(keyDeviceUUID, uuid, globalStoreConfig);
            storeApi.loadUUID();
        }
        if (accounts) {
            await accountApi.doSaveStorageAccount(JSON.parse(accounts));
        }
        else {
            console.warn('no accounts data');
            loginFlag.canJump = true;
            window.location.assign('/');
            return;
        }
        if (info) {
            const lst = JSON.parse(info);
            const res = await storeApi.setLastAccount(lst);
            if (res === 'fail') {
                console.warn('save current account failed');
                loginFlag.canJump = true;
                window.location.assign('/');
                return;
            }
            if ((lst === null || lst === void 0 ? void 0 : lst.cookies) && (lst === null || lst === void 0 ? void 0 : lst.cookies.length) > 0) {
                try {
                    await window.electronLib.appManage.setCookieStore(lst.cookies);
                    console.log('[transfer]  finish seting cookies !!!!!- ', lst.cookies);
                }
                catch (e) {
                    console.warn(e);
                }
            }
            window.location.assign('/');
        }
        else {
            console.warn('no current account ');
            loginFlag.canJump = true;
            window.location.assign('/');
            return;
        }
        window.electronLib.storeManage.set('app', 'initAccount', 'true').then();
    }
    catch (ex) {
        console.warn('init account failed:', ex);
        loginFlag.canJump = true;
        window.location.assign('/');
    }
};
if (inWindow() &&
    window.location.href.indexOf('login') < 0 &&
    pathNotInArrJudge(window.location, ignoreLoginPath) &&
    !window.apiResposity.getSystemApi().getCurrentUser()) {
    if (isElectron() && window.electronLib && window.location.href.indexOf('init=true') >= 0) {
        loginFlag.canJump = false;
        transferData();
    }
    else {
        toLogin();
    }
}
else if (inWindow() && window.apiResposity.getSystemApi().getCurrentUser()) {
    console.log('----------pass login check-----------');
    initWindowLang(true);
    if (inWindow() && isElectron() && window.electronLib) {
        window.electronLib.storeManage.set('app', 'initAccount', 'true').then();
    }
}
if (inWindow()) {
    if (isElectron()) {
        console.log('init stat: ', process && typeof process.memoryUsage === 'function' ? process.memoryUsage() : process);
    }
    window.getSpConf = (data) => config(data);
    console.log('init stat: ', window.performance.memory);
}
